import React, { useEffect, useRef } from 'react';
import lottie, { AnimationItem } from 'lottie-web';


interface LottieToGifProps {
    animationData: object;
    isSignage?: boolean;
}

const LottieToGif: React.FC<LottieToGifProps> = ({ animationData, isSignage }) => {
    const container = useRef<HTMLDivElement>(null); // Ref to HTMLDivElement

    useEffect(() => {
        if (container.current) {
            const anim: AnimationItem = lottie.loadAnimation({
                container: container.current,
                animationData: animationData as any, // Replace with your animation JSON
                renderer: 'svg', // Set the renderer to 'svg', 'canvas', 'html' as needed
                loop: true,
                autoplay: true
            });

            // Clean up animation when component unmounts
            return () => {
                anim.destroy();
            };
        }
    }, []); // Empty dependency array ensures useEffect runs only once


    return <>{isSignage ? <div ref={container} style={{ width: 500, height: 500 }} /> : <div ref={container} style={{ width: 80, height: 80 }} />}</>;
};

export default LottieToGif;
